module.exports = __webpack_public_path__ + "img/googleplay.ad46fe73.png";